module.exports = __webpack_public_path__ + "static/media/overcome-animate.4063b2c6.svg";